import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import BilledToNew from '../billedTo/billToNew';
import PocDetailsNew from '../pocDetails/pocDetailsNew';
import Regex from 'services/utils/regex/Regex';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DocumentUploadButton from 'services/utils/fileUpload/DocumentUploadButton';
import Images from 'assets/images/imageData';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import useDebouncedApi from 'services/utils/helpers/useDebouncedApi';
import { toast } from 'react-toastify';
import ClientDetails from './clientDetails';

const ClientAddressDetailsV2 = ({ data, locationPinCode, pincodeData, clientBillingPocData, clientBillingAddress, fetchGstNumber, handleValue, prefilledData, isPocShow = true, isGstShow = false, documentUploadUrl, documentUrlData, handleClientSubmit, postSalesData, setIsLoading,documentUploadUrlPublic,
documentUrlDataPublic }) => {

  const [isNewClient, setIsNewClient] = useState(false);
  const [isNewAddress, setIsNewAddress] = useState(false);
  const [isNewPoc, setIsNewPoc] = useState(false);
  const [isEdit, setIsEdit] = useState(0);
  const [showData, setShowData] = useState('');
  const [isRegisterd, setIsRegisterd] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [isPanApplicable, setPanApplicable] = useState(false);
  const [clients, setClients] = useState(data?.clients);
  const [clientPanDetails, setClientPanDetails] = useState({});
  const [existingGST, setExistingGST] = useState(false);
  const [isGstSelected, setIsGstSelected] = useState(false);
  const [isGstValidated, setIsGstValidated] = useState(false);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showClientDetails, setShowClientDetails] = useState(false);
  const [existingAddressOptions, setExistingAddressOptions] = useState([]);
  const [isExistingAddressSelected, setIsExistingAddressSelected] = useState(false);
  const [selectedExistingAddress, setSelectedExistingAddress] = useState(null);
  const [showGstAddress, setShowGstAddress] = useState(false);
  const [existingClientPoc, setExistingClientPoc] = useState([]);
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [isGoBack, setIsGoBack] = useState(false);

  const clientInput = {
    formStage: 3,
    client_name: '',
    client_pan: '',
    client_gst: '',
    client_id: '',
    client_billing_id: '',
    client_billing_value: '',
    client_poc_id: '',
    client_poc_value: '',
    billing_address: '',
    poc_data: '',
    clientIdValue: { id: null, value: '' },
    clientBrd: '',
    gstRegis: '',
    gstNumber: '',
    gstFile: '',
    nonGstFile: '',
    gstRegisPrefilled: { id: null, name: '' },
    gstTypePrefilled: { id: null, name: '' },
    isGstApplicable: '',
    client_type: 'existing_client',
    panRegis: 0,
    is_pan_selected: isPanApplicable,
    tan_number: "",
    confirm_tan_number: "",
    tan_attachment: "",
    tan_status: "",
    panNumber: ""
  };

  const clientbillingdataInput = {
    clientaddresses: [],
    clientPoc: []
  };


  const [clientbillingdata, setClientBillingData] = useState(clientbillingdataInput);
  const [clientData, setClientData] = useState(clientInput);
  const [iCheck, setICheck] = useState('existing_client');
  const handleClientBlur = (client) => {
    if (
      Regex.number.test(client.id) &&
      !isNaN(client.id)
    ) {
      const selectedClient = clients.find(c => c.id === client.id);
      setClientData({
        ...clientData,
        client_id: client.id,
        client_name: client.value,
        client_billing_id: '',
        client_billing_value: '',
        client_poc_id: '',
        client_poc_value: '',
      });
      isGstValidated ? clientBillingAddress(client.id, 1) : clientBillingAddress(client.id);
      // clientBillingAddress(client.id);
      // return false;
    } else {

      if (isEdit == 0) {
        setClientData({
          ...clientData,
          client_billing_id: '',
          client_billing_value: '',
          client_poc_id: '',
          client_poc_value: ''
        });
      }
    }
  };

  useEffect(() => {
    setIsAddressSelected(false);
    setIsGstValidated(false);
    setShowClientDetails(false);
    setIsGoBack(false);
    if(isGstSelected==2){
      setIsRegisterd('no');
    }
  }, [isGstSelected]);

    useEffect(()=>{
        if (selectedAddress?.value !== 'Other') {
           setIsAddressSelected(true);
            setShowClientDetails(true);
            setIsAddressSelected(true);
            setShowAddAddress(false);
            const selected = addressOptions.find(opt => opt.id === selectedAddress?.id);
            if (selected) {
  
            setClientData({
              ...clientData,
              billing_address: {
                billGeoState: selected.state,
                billGeoCityId: selected.city_id,
                billGeoStateId: selected.state_id,
                pincode_id: selected.pincode_id,
                billGeoCity: selected.city,
                billPinId: selected.pincode_id,
                billPinCode: selected.pincode,
                billAddressLine1: selected.addressLine1,
                billAddressLine2: selected.addressLine2,
              }
            });
            }
        }
        else{
          setShowClientDetails(true);
          setIsAddressSelected(true);
          setShowAddAddress(true);
          setIsAddressSelected(true);
          setClientData({
            ...clientData,
            client_billing_id: 0,
            client_billing_value: selectedAddress?.value
          });
        }
    },[selectedAddress])
  
    useEffect(()=>{
      if (selectedExistingAddress?.value !== 'Other') {
        setIsExistingAddressSelected(true);
        setShowGstAddress(false);
    }
    else{
      setShowGstAddress(true);
      setIsExistingAddressSelected(true);
    }
  
    },[selectedExistingAddress])

  const handleCheckGst = useCallback(async () => {
    let cancelled = false;
    setIsLoading(true);

    const clientGst = clientData.gstNumber;
  
    try {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!clientGst || clientGst.length !== 15 || !gstRegex.test(clientGst)) {
        toast.error("Invalid GST number");
        setIsLoading(false);
        return;
      }

      const response = await axios.get(`${Config.client.getDetailsByGst}?gst=${clientGst}`);
      const result = response?.data?.response;
  
      if (!cancelled && result?.status) {
        setIsGoBack(false);
        setClientData({
          ...clientData,
          client_name: '',
          client_billing_id: '',
          client_billing_value: '',
          client_poc_id: '',
          client_poc_value: ''
        });
        if (result && result?.data && result?.data?.pan_details.clients && result.data?.pan_details?.clients.length > 0) {
          setShowClientDetails(true);
          const addressList = result.data?.address ?? [];
          const pan = result.data?.pan ?? '';
          setAddressOptions(addressList);
          setSelectedAddress(null); 
          setIsAddressSelected(false);
          setIsGstSelected(1);
          setIsRegisterd('yes');
          setIsGstValidated(true);
          setClientPanDetails(result?.data?.pan_details);
          setClients(result.data?.pan_details?.clients);
          add_existing_client();
          setICheck('existing_client'); 
          setClientData({
            ...clientData,
            panNumber: pan,
            client_pan: pan,
            panRegis: 1,
          });
          // setShowGstAddress(true);
          setShowClientDetails(true);
          setExistingAddressOptions(result?.data?.client_address);
          setExistingClientPoc(result?.data?.client_poc);
          setIsNewClient(false);
          // show_pan();
        
        } else if (response?.data?.status === false) {
          setClientPanDetails({});
          show_pan();
          setICheck('existing_client');
          setSelectedAddress(null); 
          setIsAddressSelected(false);
          setIsGstValidated(false);
          if(response?.data?.message){
            toast.error(response?.data?.message);
          }
          else{
            toast.error('Invalid GST Number');
          }
        } else {
          setIsNewClient(true);
          // setShowGstAddress(true);
          setIsRegisterd('yes');
          const addressList = result.data?.address ?? [];
          const pan = result.data?.pan ?? '';
          setAddressOptions(addressList);
          setSelectedAddress(null); 
          setIsAddressSelected(false);
          setIsGstSelected(1);
          setIsGstValidated(true);
          setICheck('new_client');
          setClientPanDetails(result?.data?.pan_details);
          add_client(result.data?.pan_details?.registered_name, clientData.panNumber);
          setClientData({
            ...clientData,
            client_name: result.data?.pan_details?.registered_name,
            client_id: '',
            client_billing_id: '',
            client_billing_value: '',
            panNumber: pan,
            client_pan: pan,
            panRegis: 2,
            client_type: 'new_client'
          });
          setShowClientDetails(true);
        }

      } else if (!cancelled) {
          toast.error(result?.message || "GST validation failed");
          setIsGstValidated(false);
      }
    } catch (error) {
      if (!cancelled) {
        toast.error("Something went wrong");
      }
    } finally {
      if (!cancelled) setIsLoading(false);
    }
  
    return () => {
      cancelled = true;
    };
  }, [clientData.gstNumber]);

  useEffect(() => {
    setTimeout(() => {
      setDisabled(false);
    }, 5000);
    if (postSalesData?.client_details && Object.keys(postSalesData?.client_details).length > 0) {
      setIsGoBack(1);
      handleClientBlur(postSalesData.client_details)
      setClientData({
        formStage: 3,
        client_name: postSalesData?.client_details?.client_name ?? '',
        client_pan: postSalesData?.client_details?.pan_number ?? '',
        client_gst: postSalesData?.client_details?.client_gst ?? '',
        client_id: postSalesData?.client_details?.id ?? '',
        client_billing_id: (postSalesData?.billing_address?.id) ? postSalesData?.billing_address?.id : (postSalesData?.commercial?.billing_id) ? postSalesData?.contract_data?.billing_id : '',
        client_billing_value: postSalesData?.billing_address?.address_line_1 + ' ' + postSalesData?.billing_address?.address_line_2 + ' ' + postSalesData?.billing_address?.geo_city + ' ' + postSalesData?.billing_address?.geo_state + ' ' + postSalesData?.billing_address?.geo_pin ?? '',
        client_poc_id: postSalesData?.poc_details?.id ?? '',
        client_poc_value: postSalesData?.poc_details?.name ?? '',
        billing_address: {
          billPinId: postSalesData?.billing_address?.geo_pin_code,
          billGeoCityId: postSalesData?.billing_address?.geo_city_id,
          billGeoStateId: postSalesData?.billing_address?.geo_state_id,
          billAddressLine1: postSalesData?.billing_address?.address_line_1,
        } ?? '',
        poc_data: postSalesData?.client_details?.client_id ?? '',
        clientIdValue: { id: null, value: '' },
        clientBrd: postSalesData?.commercial?.client_brd ?? '',
        gstRegis: postSalesData?.commercial?.gst_details?.gst_registered ?? '',
        gstNumber: postSalesData?.commercial?.gst_details?.gst_number ?? '',
        gstFile: postSalesData?.commercial?.gst_details?.gst_document ?? '',
        nonGstFile: postSalesData?.commercial?.gst_details?.upload_non_gst_disclosure_form ?? '',
        gstRegisPrefilled: { id: null, name: '' },
        gstTypePrefilled: { id: null, name: '' },
        isGstApplicable: (postSalesData?.commercial?.gst_details?.gstType == 2
          ? 'Yes'
          : (postSalesData?.commercial?.gst_details?.gstType == 1
            ? 'No'
            : '')),
        client_type: (postSalesData?.client_details?.id) ? 'existing_client' : 'new_client',
        panRegis: postSalesData?.client_details?.pan_number ? 1 : 2,
        panNumber: postSalesData?.client_details?.pan_number ?? '',
        is_pan_selected:  postSalesData?.client_details?.pan_number ? 1 : 2,
        tan_number: postSalesData?.client_details?.tan_number ?? '',
        confirm_tan_number: postSalesData?.client_details?.tan_number ?? '',
        tan_attachment: postSalesData?.client_details?.tan_document ?? '',
        tan_status: postSalesData?.client_details?.tan_status ?? '',
      })
      if(postSalesData?.commercial?.gst_details?.gst_number !='' && postSalesData?.commercial?.gst_details?.gst_number !=null){
        setIsGstSelected(1);
        setIsGstValidated(true);
      }
      else{
        setIsGstSelected(2)
        setIsGstValidated(false);
      }
      setShowClientDetails(true);
      setPanApplicable(postSalesData?.client_details?.pan_number !== '' ? true : false);
    }
  }, [postSalesData])

  useEffect(() => {
    if (
      prefilledData?.client !== undefined &&
      prefilledData?.client !== null
    ) {
      const {
        id,
        client_name
      } = prefilledData?.client;
      let clientDataId = id;

      setTimeout(() => {
        setClientData({
          ...clientData,
          client_id: clientDataId,
          client_name: client_name,
          clientIdValue: { id: clientDataId, value: client_name }
        });
        handleClientBlur(clientData.clientIdValue);
        setShowData({
          ...showData,
          client_name: client_name
        });
      }, 100);
      setIsEdit(1);
      setIsNewClient(false);
    }

    if (
      prefilledData?.client_leads_poc !== undefined &&
      prefilledData?.client_leads_poc !== null
    ) {
      const {
        id,
        name
      } = prefilledData?.client_leads_poc;
      let clientPocName = name;

      setTimeout(() => {
        setClientData({
          ...clientData,
          client_poc_id: id,
          client_poc_value: name
        });
        setShowData({
          ...showData,
          client_poc: name
        });
      }, 100);
    }

    if (
      prefilledData?.bill_to !== undefined &&
      prefilledData?.bill_to !== null
    ) {
      const {
        id,
        address_line_1,
        address_line_2,
        geo_city,
        geo_state,
        geo_pin
      } = prefilledData?.bill_to;
      let clientBillId = id;
      setTimeout(() => {
        setClientData({
          ...clientData,
          client_billing_id: id,
          client_billing_value: address_line_1 + ' ' + address_line_2 + ' ' + geo_city + ' ' + geo_state + ' ' + geo_pin,
        });
        setShowData({
          ...showData,
          bill_address: address_line_1 + ' ' + address_line_2 + ' ' + geo_city + ' ' + geo_state + ' ' + geo_pin
        });
      }, 100);
      // setShowData({
      //   client_name: client_name,
      //   client_poc: clientPocName,
      //   bill_address: address_line_1+ ' ' +address_line_2+' '+geo_city+' '+geo_state+' '+geo_pin
      // })
    }
  }, [prefilledData]);

  useEffect(() => {
    if (clientBillingPocData !== undefined && clientBillingPocData !== null) {
      if (!Array.isArray(clientBillingPocData)) {
        let {
          clientbillingaddress,
          clientPoc,
          tanData
        } = clientBillingPocData;

        const updatedAddresses = [
          ...(clientbillingaddress || []),
          { id: 0, name: 'Other' }
        ];
        
        // Auto-select if only one address exists
        let autoSelectedAddress = {};
        if (clientbillingaddress && clientbillingaddress.length === 1) {
          const addr = clientbillingaddress[0];
          autoSelectedAddress = {
            client_billing_id: addr.id,
            client_billing_value: addr.name,
          };
        }

        // Auto-select if only one POC exists
        let autoSelectedPoc = {};
        if (clientPoc && clientPoc.length === 1) {
          const poc = clientPoc[0];
          autoSelectedPoc = {
            client_poc_id: poc.id,
            client_poc_value: poc.name
          };
        }

        setClientData(prev => ({
          ...prev,
          ...autoSelectedAddress,
          ...autoSelectedPoc,
          tan_number: tanData?.tan_number || '',
          confirm_tan_number: tanData?.tan_number || '',
          tan_attachment: tanData?.tan_document || '',
          tan_status: tanData?.tan_status || 0
        }));

        setClientBillingData({
          ...clientbillingdata,
          clientaddresses: updatedAddresses,
          clientPoc: clientPoc
        })
      }
    } else {
      setClientData({ ...clientData, client_billing_id: '', client_poc_id: '' });
    }
  }, [clientBillingPocData]);

  const handleBillTo = (val) => {
    setClientData({ ...clientData, billing_address: val });
  };

  const handlePocData = (val) => {
    setClientData({ ...clientData, poc_data: val });
  };

  const add_client = (clientName = '', panNumber = '') => {
    setIsNewClient(true);
    setIsNewAddress(false);
    setIsNewPoc(false);
    setClientData({
      ...clientData,
      client_name: clientName,
      client_pan: panNumber,
      client_gst: '',
      client_id: '',
      client_billing_id: '',
      client_billing_value: '',
      client_poc_id: '',
      client_poc_value: '',
      billing_address: '',
      poc_data: '',
      clientIdValue: { id: null, value: '' },
      clientBrd: '',
      gstRegis: '',
      gstNumber: '',
      gstFile: '',
      nonGstFile: '',
      gstRegisPrefilled: { id: null, name: '' },
      gstTypePrefilled: { id: null, name: '' },
      client_type: 'new_client',
      panRegis: 2,
      is_pan_selected: isPanApplicable,
      tan_status: '',
    });
  }

  const add_existing_client = () => {
    setIsNewClient(false);
    setClientData({
      ...clientData,
      client_name: '',
      client_pan: '',
      client_gst: '',
      client_id: '',
      client_billing_id: '',
      client_billing_value: '',
      client_poc_id: '',
      client_poc_value: '',
      billing_address: '',
      poc_data: '',
      clientIdValue: { id: null, value: '' },
      clientBrd: '',
      gstRegis: '',
      gstNumber: '',
      gstFile: '',
      nonGstFile: '',
      gstRegisPrefilled: { id: null, name: '' },
      gstTypePrefilled: { id: null, name: '' },
      client_type: 'existing_client',
      panRegis: 1,
      is_pan_selected: isPanApplicable,
      tan_status: '',
    });
  }

  const show_pan = () => {
    setIsNewClient(false);
    setClientData({
      ...clientData,
      client_name: '',
      client_pan: '',
      client_gst: '',
      client_id: '',
      client_billing_id: '',
      client_billing_value: '',
      client_poc_id: '',
      client_poc_value: '',
      billing_address: '',
      poc_data: '',
      clientIdValue: { id: null, value: '' },
      clientBrd: '',
      gstRegis: '',
      gstNumber: '',
      gstFile: '',
      nonGstFile: '',
      gstRegisPrefilled: { id: null, name: '' },
      gstTypePrefilled: { id: null, name: '' },
      client_type: 'existing_client',
      panRegis: 0,
      panNumber: '',
      is_pan_selected: isPanApplicable,
      tan_status: '',
    });
  }

  const add_address = () => {
    setIsNewAddress(true);
    setClientData({
      ...clientData,
      client_billing_value: '',
      gstRegis: '',
    });
    setExistingGST(false);
    add_new_address();
  }

  const add_existing_address = () => {
    setIsNewAddress(false);
    setShowAddAddress(true);
    setSelectedExistingAddress({id:0,value:'Other'});
    setClientData({
      ...clientData,
      billing_address: {
        billGeoState: '',
        billGeoCityId: '',
        billGeoStateId: '',
        pincode_id: '',
        billGeoCity: '',
        billPinId: '',
        billAddressLine1: '',
        billAddressLine2: '',
      }
    });
  }

  const add_poc = () => {
    setIsNewPoc(true);
    setClientData({
      ...clientData,
      client_poc_id: '',
      client_poc_value: ''
    });
  }

  const add_existing_poc = () => {
    setIsNewPoc(false);
  }

  const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;

  const add_new_client = () => {
    return (
      <div className='row mt-3 mb-3 p-3 border rounded bg-light'>
        <div className='col-md-12 mb-3'>
            <h6 className='text-muted'>Add New Client Details</h6>
        </div>
        <div className='col-md-12'>
          <ConstantInput
            label={localization.clientName}
            handleChange={(val) => {
              setClientData({ ...clientData, client_name: val });
            }}
            errorMsg={'Enter Client name'}
            value={clientData?.client_name}
            disabled={clientPanDetails?.registered_name && clientPanDetails.registered_name !== '' ? true : false}
            required
            isStarRequired={true}
          />
        </div>
        <div className="col-md-6 mt-2">
          <ConstantInput
            label={localization.tanNumber}
            type="password"
            handleChange={(val) => {
              setClientData({ ...clientData, tan_number: val.toUpperCase() });
            }}
            onPaste={(e) => e.preventDefault()}
          />
          {clientData.tan_number && !tanRegex.test(clientData.tan_number) && (
            <div style={{ color: 'red' }}>Invalid TAN number format</div>
          )}
        </div>
        <div className="col-md-6 mt-2">
          <ConstantInput
            label={localization.confirmTanNumber}
            maxLength={10}
            handleChange={(val) => {
              setClientData({ ...clientData, confirm_tan_number: val.toUpperCase() });
            }}
            onPaste={(e) => e.preventDefault()}
          />
          {clientData?.confirm_tan_number &&
            clientData?.tan_number !== clientData?.confirm_tan_number && (
              <div style={{ color: 'red' }}>TAN numbers do not match</div>
            )}
        </div>
        <div className='col-md-6 mt-2' style={{ wordBreak: 'break-all' }}>
          <DocumentUploadButton
            value={clientData.tan_attachment}
            onUpload={(url) =>
              setClientData((prev) => ({ ...prev, tan_attachment: url }))
            }
            accept=".pdf,.png,.jpg,image/jpeg,image/png,application/pdf"
            uploadOptions={{ service_name: 'carnival' }}
            buttonLabel={localization.tanAttachment}
            uploadedLabel={`✓ ${localization.tanAttachment} — click to change`}
            removeAriaLabel={localization.remove}
            required
            className="mb-2"
          />
        </div>
      </div>
    );
  };

  const add_new_address = () => {
    return (
      <div className='row mt-3 mb-3 p-3 border rounded bg-light'>
        <div className='col-md-12 mb-3 d-flex justify-content-between align-items-center'>
            <h6 className='text-muted mb-0'>Add New Address</h6>
            {isNewAddress && (
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={add_existing_address}>
                {localization.addExistingAddress}
              </button>
            )}
        </div>
        <div className='col-md-12'>
            <BilledToNew
            handleValue={handleBillTo}
            locationPinCode={locationPinCode}
            pincodeData={pincodeData}
            />
        </div>
      </div>
    );
  };

  const add_new_poc = () => {
    return (
      <div className='row mt-3 mb-3 p-3 border rounded bg-light'>
        <div className='col-md-12 mb-3 d-flex justify-content-between align-items-center'>
            <h6 className='text-muted mb-0'>Add New POC</h6>
            {isNewPoc && (
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={add_existing_poc}>
                {localization.addExistingPoc}
                </button>
            )}
        </div>
        <div className='col-md-12'>
            <PocDetailsNew
            handleValue={handlePocData}
            appartmentDropDown={data}
            fromPostsales={true}
            />
        </div>
      </div>
    );
  };
  const handleFormData = () => {
    if (clientData) {
      handleValue(clientData);
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [clientData]);

  const handleClientType = (value) => {
    setICheck(value);
    if (value === 'new_client') {
      add_client();

    }
    if (value === 'existing_client') {
      add_existing_client();
    }
  }

  useEffect(() => {
    if (iCheck === 'new_client') {
      setClientData({ ...clientData, gstFile: '' });
    }
  }, [iCheck]);

  const handleChangeGst = (val) => {
    setIsRegisterd(val?.value?.toLowerCase());
    setClientData({
      ...clientData,
      gstRegis: (val?.id == 1) ? 1 : 2
    });
  };

  const handleGstApplicable = (val) => {
    setClientData({
      ...clientData,
      isGstApplicable: val?.value
    });
  };

  const handlSelectPan = (val) => {
    setClientPanDetails({});
    setPanApplicable(val?.value === 'Yes' ? true : false);
    if (val?.value === 'No') {
      add_client();
    } else {
      show_pan();
    }
  };

  useEffect(() => {
    setClientData({
      ...clientData,
      is_pan_selected: isPanApplicable
    });
  }, [isPanApplicable])

  const handleChangePan = (val) => {
    setClientPanDetails({});
    setClientData({
      ...clientData,
      panNumber: val
    });
  };

  useEffect(()=>{
    if(isGstSelected == 2 && (isPanApplicable===false || data.is_pan_required==false)){
      setShowClientDetails(true);
    }
  },[isGstSelected],[isPanApplicable])

  const handleCheckPan = async () => {
    try {
      if (!clientData?.panNumber) {
        toast.error('PAN number is required');
        return false;
      }
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (clientData.panNumber.length === 10 && !panRegex.test(clientData.panNumber)) {
        toast.error("Invalid PAN format. It should be like ABCDE1234F.");
        return false;
      } else if (clientData.panNumber.length !== 10) {
        toast.error("Invalid PAN length.");
        return false;
      }
      setIsLoading(true);
      setExistingGST(false);
      setIsGoBack(false);
      const response = await axios.get(`${Config.client.getClientByPan}?client_pan=${clientData.panNumber}`);
      if (response !== null && response?.data) {
        const panPayload = response?.data?.response?.data ?? response?.data?.data;
        if (panPayload?.clients?.length > 0) {
          setClientPanDetails(panPayload);
          add_existing_client();
          setClients(panPayload?.clients);
          setShowClientDetails(true);
          setICheck('existing_client');
          setShowAddAddress(true);
        } else if (
          (response?.data?.status === false || response?.data?.status === 1) &&
          response?.data?.message === 'Pan number is invalid'
        ) {
          setClientPanDetails({});
          show_pan();
          setShowClientDetails(true);
          setICheck('existing_client');
          toast.error(response?.data?.message);
        } else {
          setShowAddAddress(true);
          setClientPanDetails(panPayload);
          add_client(panPayload?.registered_name, clientData.panNumber);
          setShowClientDetails(true);
          setICheck('new_client');
        }
      }
      setIsLoading(false);
    } catch (err) {
      const errMsg = err?.response?.data?.message ?? err?.response?.data?.response?.message;
      if (errMsg === 'Pan number is invalid') {
        setIsLoading(false);
        toast.error(errMsg);
        return;
      }
      setIsLoading(false);
      toast.error("Error in checking PAN Number");
      return;
    }
  }

  const handleGstCall = async (billingAddressId) => {
    if (billingAddressId) {
      const url = `${Config.client.fetchBillingGST}?billing_address_id=${billingAddressId}`;
      const gst = await axios.get(url);
      const gstValue = typeof gst.data === "string" ? gst.data : (gst.data?.data ?? gst.data?.response?.data ?? "");
      if (gst != null && gst.data != null) {
        setExistingGST(true);
        setClientData({ ...clientData, gstNumber: gstValue });
      }else{
        setExistingGST(false);
      }
    }
  }

  useEffect(() => {
    if(!isGstSelected==1 && !isGstValidated){
    if (clientData.client_billing_id != '') {
      handleGstCall(clientData.client_billing_id);
    } else {
      setClientData({ ...clientData, gstNumber: '' });
    }
  }
  }, [clientData.client_billing_id]);

  return (
    <Fragment>
      <div className='card mb-3'>
        <div className='card-header n-card'>
          <h5 className='mb-0'>Client</h5>
        </div>
        <div className='card-body'>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <DropDownInput
                data={[
                  { name: 'Yes', id: 1 },
                  { name: 'No', id: 2 },
                ]}
                label={localization.gstRegis}
                required
                isStarRequired={true}
                errorMsg={localization.requiredgstDetails}
                getIdValue={(val) => handleGstApplicable(val)}
                value={clientData?.isGstApplicable}
              />
            </div>

            {(isEdit == 0) && (
              <div className='col-md-6 mb-3'>
                <DropDownInput
                  data={[{ id: 1, name: "Yes" }, { id: 2, name: "No" }]}
                  label={localization.gstConfirmation}
                  required
                  getIdValue={(val) => {
                    setIsGstSelected(val.id);
                  }}
                  getValueById={isGstSelected}
                  isStarRequired={true}
                />
              </div>
            )}

            {(isGstSelected && isGstSelected == 1) && (
              <div className='col-md-6 mb-3'>
                <ConstantInput
                  label='GST Number'
                  isStarRequired={true}
                  handleChange={(val) => {
                    setClientData({
                      ...clientData,
                      gstNumber: val.toUpperCase()
                    });
                  }}
                  required={true}
                  value={clientData?.gstNumber}
                  disabled={isGoBack == 1}
                />
                {!isGstValidated && (
                  <div className="mt-2 text-right">
                    <button type="button" className="btn btn-theme btn-sm" onClick={handleCheckGst}>
                      Check GST
                    </button>
                  </div>
                )}
              </div>
            )}

            {data.is_pan_required === false && isEdit == 0 && isGstSelected == 2 && (
              <div className='col-md-6 mb-3'>
                <DropDownInput
                  data={[
                    { name: 'Yes', id: 1 },
                    { name: 'No', id: 2 },
                  ]}
                  label={localization.isPanNumberReq}
                  required
                  isStarRequired={true}
                  errorMsg={localization.isPanNumberReq}
                  getIdValue={(val) => handlSelectPan(val)}
                  value={isPanApplicable === true ? 'Yes' : 'No'}
                />
              </div>
            )}

            {(((data.is_pan_required === true || isPanApplicable === true) && isGstSelected === 2) || (isGstSelected === 1 && isGstValidated)) && (
              <div className='col-md-6 mb-3'>
                <ConstantInput
                  label={localization.requiredPan}
                  isStarRequired={true}
                  type="text"
                  maxLength={10}
                  style={{ textTransform: "uppercase" }}
                  handleChange={(val) => handleChangePan(val.toUpperCase())}
                  value={clientData.panNumber}
                  disabled={isGstValidated && clientData.panNumber}
                />
                {(!isGstValidated || isGstSelected == 2) && (
                  <div className="mt-2 text-right">
                    <button type="button" className="btn btn-theme btn-sm" onClick={handleCheckPan}>
                      {localization.checkPan}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showClientDetails && (
        <div className='card mb-3'>
          <div className='card-header n-card'>
            <h5 className='mb-0'>Client Details</h5>
            {isGoBack == 1 && (
              <small className='text-danger d-block mt-1'>
                * If you need to edit client details, please refill the above fields
              </small>
            )}
          </div>
          <div className='card-body'>
            {isEdit == 1 && (
              <div className='mb-4 p-3 bg-light rounded'>
                <ul className='mb-0 text-muted'>
                  <li><strong>Client Name:</strong> {showData?.client_name}</li>
                  <li><strong>Client POC:</strong> {showData?.client_poc}</li>
                  <li><strong>Billing Address:</strong> {showData?.bill_address}</li>
                </ul>
              </div>
            )}

            <div className='row'>
              {isNewClient === false && clientData?.panRegis === 1 && isEdit == 0 ? (
                <div className="col-md-6 mb-3">
                  <DropDownInput
                    label={localization.selectClient}
                    data={clients}
                    required
                    errorMsg={localization.requiredClientName}
                    getIdValue={(val) => {
                      handleClientBlur(val);
                    }}
                    value={clientData?.client_name}
                    isStarRequired={true}
                    disabled={isGoBack == 1}
                  />
                </div>
              ) : clientData?.panRegis === 2 ? (
                <div className="col-md-12 mb-3">
                  {add_new_client()}
                </div>
              ) : null}

              {isNewClient === false && clientData?.panRegis === 1 && isEdit == 0 && isNewAddress === false ? (
                <div className="col-md-6 mb-3">
                  <DropDownInput
                    label={localization.billingAddress}
                    data={clientbillingdata.clientaddresses}
                    required
                    errorMsg={localization.requiredBillingAddress}
                    getIdValue={(val) => {
                      setClientData({
                        ...clientData,
                        client_billing_id: val.id,
                        client_billing_value: val.value,
                      });
                      setSelectedExistingAddress(val);
                    }}
                    value={clientData.client_billing_value.length > 0 ? clientData.client_billing_value : ''}
                    isStarRequired={true}
                    disabled={isGoBack == 1}
                  />
                  {showAddAddress && (
                    <div className="mt-2 text-right">
                      <button type="button" className="btn btn-theme btn-sm" onClick={add_address}>
                        {localization.addAddress}
                      </button>
                    </div>
                  )}
                </div>
              ) : (clientData?.panRegis === 2 || isNewAddress === true) ? (
                <div className="col-md-12 mb-3">
                  {add_new_address()}
                </div>
              ) : null}

              {isNewClient === false && clientData?.panRegis === 1 && isEdit == 0 && isNewPoc === false ? (
                <div className="col-md-6 mb-3">
                  <DropDownInput
                    label={localization.clientPoc}
                    data={clientbillingdata.clientPoc}
                    required
                    errorMsg={localization.requiredClientPoc}
                    getIdValue={(val) => {
                      setClientData({
                        ...clientData,
                        client_poc_id: val.id,
                        client_poc_value: val.value
                      });
                    }}
                    value={clientData.client_poc_value.length > 0 ? clientData.client_poc_value : ''}
                    isStarRequired={true}
                    disabled={isGoBack == 1}
                  />
                  {isPocShow && (
                    <div className="mt-2 text-right">
                      <button type="button" className="btn btn-theme btn-sm" onClick={add_poc}>
                        {localization.addPOCButton}
                      </button>
                    </div>
                  )}
                </div>
              ) : (clientData?.panRegis === 2 || clientData?.panRegis == 1) ? (
                <div className="col-md-12 mb-3">
                  {add_new_poc()}
                </div>
              ) : null}

              {(isGstSelected == 1 && isGstValidated && showGstAddress) && (
                <div className='col-md-6 mb-3'>
                  <DropDownInput
                    data={addressOptions}
                    label="Select GST address"
                    required
                    getIdValue={(val) => {
                      if (val) {
                        setSelectedAddress(val);
                        setIsAddressSelected(true);
                      } else {
                        setSelectedAddress(null);
                        setIsAddressSelected(false);
                      }
                    }}
                    isStarRequired={true}
                  />
                </div>
              )}

              {(isNewClient === false && clientData?.panRegis == 1 && isEdit == 0 && existingGST === true) && (
                <div className="col-md-6 mb-3" style={{ wordBreak: 'break-all' }}>
                  <FileUpload
                    id="gst_docs_existing"
                    accept=".pdf,.png,.jpg"
                    documentUploadUrl={documentUploadUrl}
                    documentUrlData={documentUrlData}
                    reset={false}
                    onChange={(val) => {
                      setClientData({ ...clientData, gstFile: val });
                    }}
                    prefilledFilename={clientData.gstFile}
                    required
                  >
                    <span className="btn btn-theme mb-2 btn-sm">
                      {localization.uploadDocs}
                    </span>
                  </FileUpload>
                  <div className="mt-1">
                    <label className={`text-danger small ${clientData?.gstFile === '' ? 'd-block' : 'd-none'}`}>
                      {localization.GSTDocument}
                    </label>
                  </div>
                </div>
              )}

              {((clientData?.panRegis === 1 || clientData?.panRegis === 2) && isEdit == 0 && existingGST === false) && (
                <Fragment>
                  {isRegisterd === 'yes' && (
                    <div className="col-md-6 mb-3" style={{ wordBreak: 'break-all' }}>
                      <FileUpload
                        id="gst_docs_new"
                        accept=".pdf,.png,.jpg"
                        documentUploadUrl={documentUploadUrl}
                        documentUrlData={documentUrlData}
                        reset={false}
                        onChange={(val) => {
                          setClientData({ ...clientData, gstFile: val });
                        }}
                        prefilledFilename={clientData.gstFile}
                        required
                      >
                        <span className="btn btn-theme mb-2 btn-sm">
                          {localization.uploadDocs}
                        </span>
                      </FileUpload>
                      <div className="mt-1">
                        <label className={`text-danger small ${clientData?.gstFile === '' ? 'd-block' : 'd-none'}`}>
                          {localization.GSTDocument}
                        </label>
                      </div>
                    </div>
                  )}

                  {isRegisterd === 'no' && (
                    <div className="col-md-6 mb-3" style={{ wordBreak: 'break-all' }}>
                      <FileUpload
                        id="uploadNonGST"
                        accept=".pdf,.png,.jpg"
                        documentUploadUrl={documentUploadUrl}
                        documentUrlData={documentUrlData}
                        onChange={(val) => setClientData({ ...clientData, nonGstFile: val })}
                        prefilledFilename={clientData.nonGstFile}
                        reset={false}
                      >
                        <span className="btn btn-theme mb-2 btn-sm">
                          {localization.uploadNonGST}
                        </span>
                      </FileUpload>
                    </div>
                  )}
                </Fragment>
              )}

              {(isNewClient === false && clientData?.panRegis === 1 && isEdit == 0) && (
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <ConstantInput
                        label={localization.tanNumber}
                        type="password"
                        value={clientData.tan_number}
                        handleChange={(val) => {
                          setClientData({
                            ...clientData,
                            tan_number: val.toUpperCase(),
                          });
                        }}
                        onPaste={(e) => e.preventDefault()}
                        disabled={clientData?.tan_status === 1}
                      />
                      {clientData.tan_number && !tanRegex.test(clientData.tan_number) && (
                        <div style={{ color: 'red', fontSize: '12px' }}>Invalid TAN number format</div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <ConstantInput
                        label={localization.confirmTanNumber}
                        maxLength={10}
                        value={clientData.confirm_tan_number}
                        handleChange={(val) => {
                          setClientData({
                            ...clientData,
                            confirm_tan_number: val.toUpperCase(),
                          });
                        }}
                        onPaste={(e) => e.preventDefault()}
                        disabled={clientData?.tan_status === 1}
                      />
                      {clientData?.confirm_tan_number &&
                        clientData?.tan_number !== clientData?.confirm_tan_number && (
                          <div style={{ color: 'red', fontSize: '12px' }}>TAN numbers do not match</div>
                      )}
                      {clientData.tan_status == 1 && (
                          <div style={{ color: 'green', fontSize: '12px' }}>TAN already approved by finance team</div>
                      )}  
                    </div>
                    {clientData?.tan_status != 1 &&
                      <div className='col-md-6 mb-3' style={{ wordBreak: 'break-all' }}>
                        <DocumentUploadButton
                          value={clientData.tan_attachment}
                          onUpload={(url) =>
                            setClientData((prev) => ({ ...prev, tan_attachment: url }))
                          }
                          accept=".pdf,.png,.jpg,image/jpeg,image/png,application/pdf"
                          uploadOptions={{ service_name: 'carnival' }}
                          buttonLabel={localization.tanAttachment}
                          uploadedLabel={`✓ ${localization.tanAttachment} — click to change`}
                          removeAriaLabel={localization.remove}
                          required
                          className="mb-2"
                        />
                      </div>
                    }
                  </div>
                </div>
              )}
            </div>

            {isGstShow && (
              <div className="row mt-3">
                <div className="col-md-6">
                  <ConstantInput
                    label={localization.gstNumber}
                    maxLength={15}
                    handleChange={(val) => {
                      setClientData({
                        ...clientData,
                        client_gst: val,
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className='card mb-3'>
        <div className='card-header n-card'>
          <h5 className='mb-0'>{localization.clientBrd}</h5>
        </div>
        <div className='card-body'>
          <div className="row">
            <div className="col-md-6" style={{ wordBreak: 'break-all' }}>
              <FileUpload
                id="filDoc_1"
                accept=".pdf,.png,.jpg"
                documentUploadUrl={documentUploadUrl}
                onChange={(val) => setClientData({
                  ...clientData,
                  clientBrd: val,
                })}
                prefilledFilename={clientData.clientBrd}
                reset={false}
              >
                <span className="btn btn-theme mb-2 btn-sm">
                  {localization.clientBrd}
                </span>
              </FileUpload>
            </div>
          </div>
        </div>
      </div>

      <div className='row mt-4 mb-4'>
        <div className='col-md-12 text-right'>
          <button type="button" onClick={() => handleClientSubmit()} className='btn btn-theme px-4 py-2' disabled={disabled}>
            Save & Next
          </button>
        </div>
      </div>
    </Fragment>
  );
};

ClientAddressDetailsV2.propTypes = {
  handleValue: PropTypes.func,
  handleClientSubmit: PropTypes.func
};

export default ClientAddressDetailsV2;
